import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'
import { TokenPrice } from '../../interfaces/common'
import { PerpPosition } from '../../interfaces/hyperliquid'

export interface TokenBalance {
  id: string
  balance: string
}

export interface PerpsAccountBalance {
  totalBalance: number
  withdrawableBalance: number
  assetPositions: PerpPosition[]
}

interface UserTokenBalanceStore {
  balances: { [key: string]: TokenBalance[] }
  perpsAccountBalances: { [key: string]: PerpsAccountBalance }
  balancesForWallet: (walletId: string) => TokenBalance[]
  setBalance: (tokenId: string, walletId: string, balance: string) => void
  setBalances: (walletId: string, newBalances: TokenBalance[]) => void
  setPerpsAccountBalance: (walletId: string, newBalance: PerpsAccountBalance) => void
  tokenPrices: TokenPrice[]
  setTokenPrices: (prices: TokenPrice[]) => void
}

export const createTokenBalancesStore = (storage: StateStorage) =>
  createStore<UserTokenBalanceStore>(
    storage,
    (set, get) => ({
      balances: {},
      perpsAccountBalances: {},
      tokenPrices: [],
      balancesForWallet(walletId) {
        return get().balances[walletId] || []
      },
      setBalance(tokenId, walletId, balance) {
        const balances = get().balances
        const currentBalances = balances[walletId] || []
        if (currentBalances.find((balance) => balance.id === tokenId)) {
          set({
            balances: {
              ...balances,
              [walletId]: [
                ...currentBalances.filter((balance) => balance.id !== tokenId),
                { id: tokenId, balance },
              ],
            },
          })
        } else {
          set({
            balances: {
              ...balances,
              [walletId]: [...currentBalances, { id: tokenId, balance }],
            },
          })
        }
      },
      setPerpsAccountBalance(walletId, newBalance) {
        const perpsAccountBalances = get().perpsAccountBalances
        set({ perpsAccountBalances: { ...perpsAccountBalances, [walletId]: newBalance } })
      },
      setBalances(walletId, newBalances) {
        const balances = get().balances
        const oldBalances = (balances[walletId] || []).filter(
          (b) => !newBalances.map((nb) => nb.id).includes(b.id)
        )

        set({
          balances: {
            ...balances,
            [walletId]: [...oldBalances, ...newBalances],
          },
        })
      },
      setTokenPrices(prices) {
        set({ tokenPrices: prices })
      },
    }),
    {
      persist: {
        name: 'userTokenBalances1',
        version: 0,
      },
    }
  )
